import { Field, FormikProps } from 'formik'
import { parsePhoneNumberFromString } from 'libphonenumber-js/min'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { TextField } from '../../field'

interface Props {
  name: string
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  onChange?: (_: any, form: FormikProps<any>) => void
}

export function validatePhone(value: any) {
    if (!value) return null;

    // Numbers without a country code (e.g. local Finnish format) are assumed to be Finnish.
    // Numbers with a country code (e.g. +46.../00358...) are validated against that country instead.
    const phone = parsePhoneNumberFromString(value, 'FI');

    if (!phone || !phone.isPossible()) {
        return 'Virheellinen puhelinnumero';
    }

    return null;
}

export const PhoneInput: React.FunctionComponent<Props> = ({
  name,
  label,
  placeholder,
  disabled,
  required,
  onChange,
}) => {
  const intl = useIntl()
  /**
   * we only validate the phone number in the input field when changed because
   * phonenumbers retrieved from pertti can be invalid according to validation
   * rules. We still want to show them!
   */
  const validate = useCallback(
    (value: string | null): string | undefined => {
      if (disabled) return undefined
      if (required && (!value || !value.trim())) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }

      if (value) {
        const parsed = validatePhone(value);
        if (parsed) {
          return parsed;
        }
      }

      // if (value && !value.match(/^\+?[\d\-\s]{5}[\d\-\s]+$/)){
      //   return 'Virheellinen puhelinnumero'
      // }

      return undefined
    },
    [required, disabled, intl]
  )

  return (
    <Field
      component={TextField}
      id={name}
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      validate={validate}
      disabled={disabled}
      onValueChange={onChange}
    />
  )
}
